var o = /* @__PURE__ */ ((r) => (r.medium = "medium", r.large = "large", r))(o || {}), m = /* @__PURE__ */ ((r) => (r.row = "row", r.column = "column", r))(m || {});
const u = Symbol("CheckboxGroup");
export {
  m as CheckboxDirections,
  u as CheckboxGroupSymbol,
  o as CheckboxSizes
};
